import React, { useEffect, useState, useCallback, useMemo } from "react";
import { IoHomeOutline } from "react-icons/io5";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { Link, useLocation } from "react-router-dom";
import Personal from "./Personal";
import Education from "./Education";
import Projects from "./Projects";
import Beceriler from "./Beceriler";
import Dilbilgisi from "./Dilbilgisi";
import SocialMedia from "../Hesabim/SocialMedia";
import { useDispatch, useSelector } from "react-redux";
import { getUserById } from "../../redux/actions/otherUserAction";
import DetayLoader from "../../components/loader/detayLoader";
import { getProfileImage } from "../../redux/actions/imgAction";
import api from "../../utils/apiAuth";
import { toast } from "react-toastify";

const Detay = ({ page }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { userId } = location.state || {};
  const { otherUser, loading, error } = useSelector((state) => state.otherUser);
  const { imageData } = useSelector((state) => state.img);
  const currentUserId = useSelector((state) => state.auth.userId);
  const { user } = useSelector((state) => state.user);
  const [otherUserProject, setOtherUserProject] = useState(null);
  const [currentUserProject, setCurrentUserProject] = useState(null);
  const [discardError, setDiscardError] = useState(null);
  const [discardResponse, setDiscardResponse] = useState(null);

  useEffect(() => {
    if (userId) {
      dispatch(getUserById(userId));
    }

    const fetchCurrentUserProject = async () => {
      try {
        const response = await api.get(
          `/projects/userProjects/${currentUserId}`
        );
        if (response.data.data && response.data.data.length > 0) {
          setCurrentUserProject(response.data.data[0]);
        } else {
          setCurrentUserProject(null);
        }
      } catch (error) {
        console.error("Error fetching current user project:", error);
        setCurrentUserProject(null);
      }
    };

    if (currentUserId) {
      fetchCurrentUserProject();
    }

    const fetchOtherUserProject = async () => {
      try {
        const response = await api.get(`/projects/userProjects/${userId}`);
        if (response.data.data && response.data.data.length > 0) {
          setOtherUserProject(response.data.data[0]);
        } else {
          setOtherUserProject(null);
        }
      } catch (error) {
        console.error("Error fetching other user project:", error);
        setOtherUserProject(null);
      }
    };

    if (userId) {
      fetchOtherUserProject();
    }
  }, [dispatch, userId, currentUserId]);

  useEffect(() => {
    if (userId) {
      dispatch(getProfileImage(userId));
    }
  }, [dispatch, userId]);

  const getImageSrc = useCallback(() => {
    if (
      imageData[userId]?.data?.length > 0 &&
      imageData[userId].data[0].content
    ) {
      return `data:image/jpeg;base64,${imageData[userId].data[0].content}`;
    }
    return "/defaultPerson.svg";
  }, [imageData, userId]);

  const handleDiscardSenior = useCallback(async () => {
    try {
      setDiscardError(null);
      const response = await api.post(`votes/DiscardWantedSenior/${userId}`);
      setDiscardResponse(response.data.message);
      toast.success("Sonlandırma isteğiniz başarıyla gerçekleşti", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } catch (error) {
      setDiscardResponse(null);
      console.error("Mentör çalışması sonlandırma hatası:", error);
      if (error.response?.status === 401) {
        setDiscardError("Oturum süreniz dolmuş. Lütfen tekrar giriş yapın.");
      } else {
        setDiscardError(error.response?.data?.message || "Bir hata oluştu");
      }
      toast.error(error.response?.data?.message || "Bir hata oluştu", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  }, [userId]);

  // Memoize the image source
  const imageSrc = useMemo(() => getImageSrc(), [getImageSrc]);

  const socialMediaInfo = useMemo(() => {
    if (!otherUser?.data?.social_medias)
      return {
        linkedin: "--",
        instagram: "--",
        github: "--",
        behance: "--",
      };

    return {
      linkedin:
        (
          otherUser.data.social_medias?.find((s) => s.startsWith("linkedin")) ||
          ""
        ).replace("linkedin:", "") || "--",
      instagram:
        (
          otherUser.data.social_medias?.find((s) =>
            s.startsWith("instagram")
          ) || ""
        ).replace("instagram:", "") || "--",
      github:
        (
          otherUser.data.social_medias?.find((s) => s.startsWith("github")) ||
          ""
        ).replace("github:", "") || "--",
      behance:
        (
          otherUser.data.social_medias?.find((s) => s.startsWith("behance")) ||
          ""
        ).replace("behance:", "") || "--",
    };
  }, [otherUser?.data?.social_medias]);

  const isInSameProject = useMemo(() => {
    if (!currentUserProject || !otherUserProject) return false;
    return String(currentUserProject.id) === String(otherUserProject.id);
  }, [currentUserProject, otherUserProject, user, otherUser]);

  useEffect(() => {}, [currentUserId, userId, otherUser]);

  if (loading) return <DetayLoader />;
  if (error) return <p>Hata: {error}</p>;
  if (!otherUser) return <p>Kullanıcı bulunamadı.</p>;

  return (
    <div className="containerMain flex flex-col gap-8">
      <div className="baslik flex flex-col gap-4">
        <h1 className="text-2xl font-bold">
          {page === "juniorDetay" ? "Juniorlar" : "Seniorlar"}
        </h1>
        <div className="text-sm text-grayy flex items-center gap-2 font-medium">
          <IoHomeOutline className="w-4 h-4" />
          <Link to="/">Anasayfa</Link>
          <MdOutlineKeyboardArrowRight className="w-6 h-6" />
          <Link
            to={`/${page === "juniorDetay" ? "juniorlar" : "seniorlar"}`}
            className="text-grayy"
          >
            {page === "juniorDetay" ? "Juniorlar" : "Seniorlar"}
          </Link>
          <MdOutlineKeyboardArrowRight className="w-6 h-6" />
          <span className="text-darkerGreen">{otherUser?.data?.name}</span>
        </div>
      </div>
      <div className="detaylar grid grid-cols-1 md:grid-cols-2 gap-8">
        <div className="left-area flex flex-col gap-8 w-full">
          <Personal
            imageSrc={imageSrc}
            userData={otherUser?.data}
            isInSameProject={isInSameProject}
          />
          <Education page="detay" detayUserData={otherUser?.data} />
          <Projects
            page="detay"
            detayUserData={otherUser?.data}
            detayUserId={currentUserId}
          />
        </div>
        <div className="rght-area flex flex-col gap-8">
          <Beceriler
            page="detay"
            detayUserData={otherUser?.data}
            detayUserId={currentUserId}
          />
          <Dilbilgisi page="detay" detayUserData={otherUser?.data} />
        {/*   <SocialMedia socialMediaInfo={socialMediaInfo} showEdit={false} page="detay" /> */}

          {!loading &&
            currentUserProject !== null &&
            otherUserProject !== null &&
            page !== "juniorDetay" &&
            user?.data?.type === "JUNIOR" &&
            currentUserProject?.title === otherUserProject?.title && (
              <div className="flex flex-col gap-2">
                <button
                  onClick={handleDiscardSenior}
                  className="text-xs text-darkBlue font-bold underline flex justify-end"
                >
                  Mentörle Çalışmayı Sonlandır
                </button>
                {discardResponse && (
                  <p className="text-xs text-right text-darkerGreen">
                    {discardResponse}
                  </p>
                )}
                {discardError && (
                  <p className="text-xs text-right text-red-500">
                    {discardError}
                  </p>
                )}
              </div>
            )}
        </div>
      </div>
    </div>
  );
};

export default React.memo(Detay);
